export enum SubstanceAbuse {
    SUBSTANCE_ABUSE_INPATIENT= "Substance abuse inpatient treatment facility",
    SUBSTANCE_ABUSE_OUTPATIENT= "Substance abuse outpatient treatment"
}